var map = {
	"./Bang Bang Booth/1.png": 662,
	"./Bang Bang Booth/2.png": 869,
	"./Bang Bang Booth/3.png": 740,
	"./Bang Bang Booth/4.png": 651,
	"./Block Puzzle Game/1.png": 871,
	"./Hue Hunter Game/1.png": 260,
	"./Hue Hunter Game/2.png": 943,
	"./Hue Hunter Game/3.png": 158,
	"./Rat Colony/1.png": 437,
	"./Row And Glow/1.png": 666,
	"./Row And Glow/2.png": 673,
	"./Row And Glow/3.png": 920,
	"./Row And Glow/4.png": 791,
	"./Word Search Game/1.png": 254,
	"./Word Search Game/2.png": 933,
	"./Word Search Game/3.png": 780,
	"./Word Search Game/4.png": 723,
	"./Word Search Game/5.png": 370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 675;